import { Link } from "@/i18n/routing";
import { ChevronRight } from "lucide-react";
import { Eyebrow } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

/**
 * Reusable inner-page hero with breadcrumb.
 * crumbs: [{ label, to }]
 */
export const PageHero = ({ eyebrow, title, subtitle, crumbs = [], children }) => (
  <header className="relative overflow-hidden border-b border-[hsl(var(--vc-line))] bg-mint vc-hero-glow">
    <div className="vc-container py-12 sm:py-16">
      {crumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="mb-5 flex flex-wrap items-center gap-1 text-xs font-medium text-[hsl(var(--vc-slate))]">
          {crumbs.map((c, i) => (
            <span key={c.label} className="flex items-center gap-1">
              {c.to ? (
                <Link to={c.to} className="hover:text-brand">{c.label}</Link>
              ) : (
                <span className="text-[hsl(var(--vc-ink))]">{c.label}</span>
              )}
              {i < crumbs.length - 1 && <ChevronRight className="h-3.5 w-3.5" />}
            </span>
          ))}
        </nav>
      )}
      <Reveal>
        {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
        <h1 className="max-w-3xl text-4xl font-extrabold tracking-tight text-[hsl(var(--vc-ink))] sm:text-5xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[hsl(var(--vc-slate))] sm:text-lg">{subtitle}</p>
        )}
        {children && <div className="mt-6">{children}</div>}
      </Reveal>
    </div>
  </header>
);

export default PageHero;
